import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f841048"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = {
  key: 0,
  class: "segmented-control"
}
const _hoisted_3 = { class: "map-content-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: $props.targetBusStop.name,
      shouldHideBackButton: true,
      onOnClickClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickClose')))
    }, null, 8 /* PROPS */, ["title"]),
    ($props.targetBusStop.shouldShowStreetView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode($setup["SegmentedControl"], {
            segments: ['지도', '거리뷰'],
            initialIndex: $setup.currentSegmentIndex,
            onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
          }, null, 8 /* PROPS */, ["initialIndex"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode($setup["NaverMap"], {
        latitude: $props.targetBusStop.latitude,
        longitude: $props.targetBusStop.longitude,
        busStops: [$props.targetBusStop],
        showCurrentLocation: false,
        selectedBusStop: $props.targetBusStop
      }, null, 8 /* PROPS */, ["latitude", "longitude", "busStops", "selectedBusStop"]), [
        [_vShow, $setup.currentSegmentIndex === 0]
      ]),
      _withDirectives(_createVNode($setup["StreetView"], {
        latitude: $props.targetBusStop.latitude,
        longitude: $props.targetBusStop.longitude
      }, null, 8 /* PROPS */, ["latitude", "longitude"]), [
        [_vShow, $props.targetBusStop.shouldShowStreetView && $setup.currentSegmentIndex === 1]
      ])
    ])
  ]))
}